import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Assemble",
    component: () => import("../views/tabs/MainPage.vue"),
  },
  {
    path: "/inner",
    name: "InnerTest",
    component: () => import("../views/inner/MainPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
